import APIService from '../api.service';

export const FetchUomConversionList = (payload) => {
  return APIService.get(`/v01/uom-conversions`, {
    params: {
      ...payload
    },
  });
};

export const FetchToUomList = ($from_uom_id) => {
  return APIService.get(`/v01/uom-conversions/to-uoms/${$from_uom_id}`);
};

export const CreateUomConversion = (body, config = {}) => {
  return APIService.post(`/v01/uom-conversions`, body, config);
};

export const UpdateUomConversion = (payload) => {
  const id = payload.id;
    return APIService.put(`/v01/uom-conversions/${id}`, {
            ...payload
    });
  };

export const DeleteUomConversion = (id) => {
    return APIService.delete(`/v01/uom-conversions/${id}`);
  };


const UomConversionService = {
 FetchUomConversionList,
 FetchToUomList,
 CreateUomConversion,
 UpdateUomConversion,
 DeleteUomConversion
};

export default UomConversionService;
